import Corolla2012 from "../images/cars-big/corolla-2012.png";
import Corolla2013 from "../images/cars-big/corolla-2013.png";
import Civic2013 from "../images/cars-big/civic2013.png";
import Tesla from "../images/cars-big/teslamodel3.png";
import Camry from "../images/cars-big/toyota-camry.png";
import Sienna from "../images/cars-big/toyotasienna2014.png";
 
export const CAR_DATA = [
  [
    {
      name: "Toyota Corolla",
      price: "45",
      img: Corolla2013,
      model: "Sedan",
      seats:"5",
      year: "2013",
      doors: "4/5",
      air: "Yes",
      transmission: "Automatic",
      fuel: "Gasoline",
    },
  ],
  [
    {
      name: "Honda Civic",
      price: "45",
      img: Civic2013,
      model: "Sedan",
      seats:"5",
      year: "2012",
      doors: "4/5",
      air: "Yes",
      transmission: "Automatic",
      fuel: "Gasoline",
    },
  ],
 
  [
    {
      name: "Toyota Camry",
      price: "50",
      img: Camry,
      model: "Sedan",
      seats:"5",
      year: "2012",
      doors: "4/5",
      air: "Yes",
      transmission: "Automatic",
      fuel: "Gasoline",
    },
  ],
  [
    {
      name: "Tesla Model 3",
      price: "77",
      img: Tesla,
      model: "Full size Sedan",
      seats:"5",
      year: "2021",
      doors: "4/5",
      air: "Yes",
      transmission: "Automatic",
      fuel: "Electric",
    },
  ],
  [
    {
      name: "Toyota Corolla 2012",
      price: "45",
      img: Corolla2012,
      model: "Sedan",
      seats:"5",
      doors: "4/5",
      air: "Yes",
      transmission: "Automatic",
      fuel: "Gasoline",
    },
  ],
   [
    {
      name: "Toyota Sienna 2014",
      price: "95",
      img: Sienna,
      model: "Minivan",
      seats:"8",
      mark: "Sienna",
      year: "2014",
      doors: "4/5",
      air: "Yes",
      transmission: "Automatic",
      fuel: "Gasoline",
    },
  ],
];
